<template>
    <div id="dashboard-component">
        <div class="row">
            <div class="col s12">
                <div class="row">
                    <div class="col s3 m2">
                        <h4>Group:</h4>
                    </div>
                    <div class="col s6 m3">
                        <select v-model="selected_group">
                            <option v-for="group in groups" :value="group.id">{{ group.name }}</option>
                        </select>
                    </div>
                </div>

                <group-summary-component
                        :group="selected_group_object"
                        :url-pdf="urlPdf"
                        :url-outstanding-issue-by-user-group="urlOutstandingIssueByUserGroup"
                ></group-summary-component>
            </div>
        </div>

        <div v-if="selected_group !== null">
            <div class="row pt-15">
                <div class="input-field col s5 m3">
                    <label style="z-index: -1;">Search Member Name</label>
                    <input type="text" v-model="search_member">
                </div>
                <div class="col s7 m4 offset-m5">
                    <div class="card horizontal show-member">
                        <div class="card-content">
                            <span>Now showing: </span><b>{{ selected_member ? selected_member.name : 'Select a member'}}</b>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" v-if="members.length > 0">
                <div class="col s12" style="overflow-x: auto;">
                    <div class="row" style="display: inline-flex">
                        <!-- v-for members -->
                        <div class="card flex-card member-card"
                             v-for="member in members"
                             :class="{ 'hide-card' : member.name.toLowerCase().indexOf(search_member.toLowerCase()) === -1 }"
                             v-on:click="changeMember(member)"
                        >
                            <div class="card-image">
                                <img src="images/icommunity_logo.svg" class="avatar">
                            </div>
                            <div class="card-content">
                                <h6 class="member-name">{{ member.name }}</h6>
                            </div>
                        </div> <!--/ v-for members -->
                    </div>
                </div>
            </div>


            <div class="row dashboard-analytic-card">
                <div class="col s12 m7 l7 xl7">
                    <stress-score-summary
                            ref="stress_score_summary"
                            :is-admin="true"
                            :halt-initiate="true"
                            :selected-user="selected_member"
                            :data-url="urlStressScoreSummary"
                    ></stress-score-summary>
                </div>
                <div class="col s12 m5 l5 xl5">
                    <div class="row">
                        <div class="col s12 m12 l12 xl12">
                            <this-month-score-summary
                                    ref="this_month_score_summary"
                                    :is-admin="true"
                                    :halt-initiate="true"
                                    :selected-user="selected_member"
                                    :data-url="urlThisMonthScoreSummary"
                            ></this-month-score-summary>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col s12 m12 l12 xl12">
                            <outstanding-issue-component
                                    ref="outstanding_issue_component_ref"
                                    :is-admin="true"
                                    :halt-initiate="true"
                                    :selected-user="selected_member"
                                    :data-url="urlOutstandingIssue"
                                    :pdf-url="urlPdf"
                            ></outstanding-issue-component>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="row">
                <div class="col s12">
                    <div class="card-panel cyan lighten-4">
                        <i class="material-icons align-middle">info_outline</i>
                        <span class="align-middle">Select a group first</span>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
  import GroupSummaryComponent from './GroupSummaryComponent'

  export default {
    name: 'DashboardComponent',
    props: {
      urlStressScoreSummary: String,
      urlThisMonthScoreSummary: String,
      urlOutstandingIssue: String,
      urlOutstandingIssueByUserGroup: String,
      urlPdf: String,
      refGroups: String
    },
    components: {
      'group-summary-component': GroupSummaryComponent
    },
    data () {
      return {
        groups: null,
        selected_group: null,
        selected_group_object: null,
        search_member: '',
        selected_member: null,
      }
    },
    computed: {
      members () {
        if (this.selected_group_object) {
          // select group first
          // if (this.search_member.length > 0) {
          //   // select member
          //   return this.selected_group_object.members.filter(member => member.name.toLowerCase().indexOf(this.search_member.toLowerCase()) >= 0 )
          // } else {
            return this.selected_group_object.members
          // }
        }
        return [];  // avoid render when member not selected
      },
    },
    watch: {
      selected_group () {
        this.selected_group_object = this.groups.filter(group => group.id == this.selected_group)[0];

        // resets
        this.search_member = '';
        this.selected_member = null;
        this.$refs.stress_score_summary.deselectUserId()
        this.$refs.this_month_score_summary.deselectUserId()
        this.$refs.outstanding_issue_component_ref.deselectUserId()
      },
    },
    mounted () {
      //console.log(this.groups);

      try {
        this.groups = JSON.parse(this.refGroups)
      } catch (e) {
        console.log(e);
      }
    },
    methods: {
      changeMember (member) {
        this.selected_member = member
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/dashboard/DashboardComponent.vue